export const DOWNLOAD_URL_QUERY = '/uploads/:id/url';
